import * as React from 'react'

import { cn } from '@/lib/utils'

/*
 * Campo de texto do GEF: o `input` do shadcn/ui com a forma dos campos do
 * protótipo do PO — 36px de altura, fundo branco, cantos de 8px e o exemplo
 * (placeholder) em itálico.
 *
 * A borda é mais escura que a desenhada: o protótipo usa um cinza que fica em
 * 1,5:1 sobre o branco, e o campo precisa de 3:1 para ser visto como campo.
 * Inválido (`aria-invalid`), a borda fica vermelha e mais grossa.
 */
function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'block h-9 w-full min-w-0 rounded-lg border border-input bg-background px-3',
        'text-base font-medium text-foreground',
        'placeholder:text-muted-foreground placeholder:italic',
        'transition-colors duration-(--gef-duracao-rapida)',
        'aria-invalid:border-2 aria-invalid:border-destructive',
        'disabled:cursor-not-allowed disabled:opacity-(--gef-desabilitado)',
        className
      )}
      {...props}
    />
  )
}

export { Input }
